import { TextPartHighlight } from '@components/Sections/Sections.styled';

import { MainTextStyled, TextPenUnderline, TextPenOutline } from './MainText.styled';

export const MainText: React.FC = () => {
  return (
    <>
      <MainTextStyled>
        The competitive gaming industry, which EX CORP. is proud to be a part of, has the potential to be one of the few
        spheres free of gender stereotypes and any form of discrimination. The esports community proclaims that{' '}
        <TextPartHighlight>
          all&nbsp;you&nbsp;need
          <TextPenUnderline width="197" height="9" viewBox="0 0 197 9" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M1.02554 3.11022C27.3793 3.32294 54.141 0.45152 80.4215 1.95774C102.415 3.21828 123.343 7.2622 145.473 7.44084C162.611 7.57917 178.535 6.84921 195.508 6.98622"
              stroke="#D9FC51"
              strokeWidth="2"
              strokeLinecap="round"
              vectorEffect="non-scaling-stroke"
            />
          </TextPenUnderline>
        </TextPartHighlight>{' '}
        to be successful is a PC and skill at your game. Whether you&apos;re a man or a woman — that&apos;s completely
        irrelevant.
      </MainTextStyled>
      <MainTextStyled>
        The relatively young age of esports and gaming communities, the fact that hierarchies are still in the process
        of being established, and the low entry barriers: these are the factors that speak in favor of a possible{' '}
        <TextPartHighlight>
          meritocratic
          <TextPenOutline
            isFullCentered
            width="215"
            height="46"
            viewBox="0 0 215 46"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M180.884 10.7716C217.829 3.2245 215.76 22.3863 211.659 29.8127C200.323 47.5898 139.867 44.6347 102.816 44.6347C45.878 42.097 -2.61512 42.5917 1.21216 22.0227C10.1276 -10.8495 162.64 3.82385 182.677 7.05613C197.558 9.4566 206.895 14.1168 207.957 15.7643"
              stroke="#D9FC51"
              strokeWidth="2"
              strokeLinecap="round"
              vectorEffect="non-scaling-stroke"
            />
          </TextPenOutline>
        </TextPartHighlight>{' '}
        system.
      </MainTextStyled>
    </>
  );
};
